// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"120":"8c2a32b5de457623","194":"769de09079d6d920"}[chunkId] + ".js";
};